<template>
    <div class="bg-dark card m-auto mnde-form text-light">
        <div class="card-header small">
            <img src="/images/projects/marinade-white.png" height="20" style="margin-right:20px"/>
            Turbo Stake for bonus APY on mSOL
        </div>
        <div class="card-body">

            <b-tabs content-class="p-2" pills>
                <b-tab title="Stake SOL" title-link-class="p-2" >
                    <div class="">
                        <b-form-group label="Amount of SOL to stake">
                            <b-input-group>
                                <b-form-input v-model="amount" type="number" class="text-light" placeholder="0.00"
                                              @input="updateMSolAmount"/>
                                <b-input-group-append>
                                    <b-button variant="outline-secondary">SOL</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <div class="small text-right" @click="amount = Math.max(solBalance-0.05,0); updateMSolAmount()">Max: {{ solBalance-0.05 }}</div>
                        </b-form-group>
                        <b-form-group label="mSOL received">
                            <b-input-group>
                                <b-form-input v-model="msolAmount" type="number" placeholder="0.00" disabled/>
                                <b-input-group-append>
                                    <b-button variant="outline-secondary">mSOL</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <div class="text-right small">1 SOL = {{ (1 / state.mSolPrice).toFixed(4) }} mSOL</div>
                        </b-form-group>
                        <b-button variant="success" size="lg" class="w-100" @click="stakeSol()" :disabled="loading && amount>0 " v-if="wallet.connected">Turbo Stake
                        </b-button>
                        <b-button disabled v-else size="lg" class="w-100 bg-secondary">Connect Your Wallet</b-button>
                        <div class="small text-center p-1">You can also deposit a stake account <a href="/go/marinade" target="_blank" class="clicky_log_outbound">using Marinade's site</a>
                        </div>
                    </div>

                </b-tab>
                <b-tab title="Unstake mSOL" title-link-class="p-2">
                    <div class="">
                         <b-form-group label="Amount of mSOL to unstake">
                             <b-input-group>
                                 <b-form-input v-model="msolAmount" type="number" class="text-light" placeholder="0.00"
                                               @input="updateMSolAmount"/>
                                 <b-input-group-append>
                                     <b-button variant="outline-secondary">mSOL</b-button>
                                 </b-input-group-append>
                             </b-input-group>
                             <div class="small text-right" @click="msolAmount = msolBalance; amount = msolBalance*state.mSolPrice;">Max: {{ msolBalance }}</div>


                         </b-form-group>
                        <b-form-group label="SOL received">
                            <b-input-group>
                                <b-form-input v-model="amount" type="number" placeholder="0.00" disabled/>
                                <b-input-group-append>
                                    <b-button variant="outline-secondary">mSOL</b-button>
                                </b-input-group-append>
                            </b-input-group>
                            <div class="text-right small">1 mSOL = {{ (state.mSolPrice).toFixed(4) }} SOL</div>
                        </b-form-group>
                        <b-button variant="warning" size="lg" class="w-100" @click="unstake()" :disabled="loading && msolAmount>0">Unstake
                        </b-button>
                        <div class="small text-center p-1">Marinade charge a 0.25% instant unstake fee
                        </div>
                    </div>

                </b-tab>
            </b-tabs>

        </div>
    </div>
</template>

<script>
import {Marinade, MarinadeConfig, Wallet, Provider, BN} from '@marinade.finance/marinade-ts-sdk'
import { useWallet } from 'solana-wallets-vue';
import {Connection, clusterApiUrl, Keypair, SystemProgram, Transaction, PublicKey} from '@solana/web3.js';
import {ElNotification} from "element-plus";

// const connection = new Connection("https://solana-mainnet.rpc.extrnode.com", "confirmed");
const connection = new Connection("https://specific-lanny-fast-mainnet.helius-rpc.com/", "confirmed");

const MY_REFERRAL_ACCOUNT = "D9d7WxBeCeNU8zECA4YKG6ciBKHQG5mqmyygCetvXz7H" // <-- your referral account

const config = new MarinadeConfig({
    connection: connection,
    // publicKey: this.wallet.pubKey,
    referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
})
const marinade = new Marinade(config)


export default {
    name: "MarinadeForm",
    data() {
        return {
            amount: 0,
            msolAmount: 0,
            loading: false,
            error: null,
            success: null,
            wallet:  useWallet(),
            provider: null,
            marinade: null,
            norefer: null,
            state: {mSolPrice: 0},
            solBalance: 0,
            msolBalance: 0,
            balances: {}

        }
    },
    async mounted() {
        this.state = await marinade.getMarinadeState()
        console.log(this.state)
        console.log(this.state.mSolPrice)
        console.log(this.wallet)
        if (this.wallet.connected) {
            this.walletBalance()
            const config = new MarinadeConfig({
                connection: connection,
                publicKey: new PublicKey(this.wallet.publicKey),

                referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
            })
            const noRefer = new MarinadeConfig({
                connection: connection,
                publicKey: new PublicKey(this.wallet.publicKey),
            })
            this.marinade = new Marinade(config)
            this.norefer = new Marinade(noRefer)
        }
    },
    methods: {
        sendTx: async function (transaction) {
            try {
                const txid = await this.wallet.sendTransaction(transaction, connection)
                console.log('tx sent')
                const getConfirmation = async (connection, tx) => {
                    const result = await connection.getSignatureStatus(tx, {
                        searchTransactionHistory: true,
                    });
                    return result;
                };
                const result = await getConfirmation(connection, txid);
                console.log('tx processed', result)
                if (result) {
                    ElNotification({
                        title: 'Success',
                        message: 'Successfully staked SOL for mSOL',
                        type: 'success',
                        duration: 5000,
                        customClass: 'text-left'
                    })

                } else {
                    ElNotification({
                        title: 'Error',
                        message: 'Transaction failed',
                        type: 'error',
                        customClass: 'text-left',
                        duration: 5000
                    })
                    this.error = "Transaction failed"
                }
            } catch (e) {
                console.log(e)
                this.error = e
                ElNotification({
                    title: 'Error',
                    message: "Transaction failed:\n" + e,
                    type: 'error',
                    customClass: 'text-left',
                    duration: 5000
                })
            }
            this.walletBalance()
            this.loading = false
        },
        async stakeSol() {
            this.loading = true
            this.error = null
            this.success = null
            console.log(this.wallet.publicKey)
            console.log(this.marinade)
            const {
                associatedMSolTokenAccountAddress,
                transaction,
            } = await this.marinade.deposit( new BN(this.amount * 1e9), {
                directToValidatorVoteAddress: "EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72",
            })
            console.log(transaction, "transaction")

            // let voteIx = await this.marinade.createDirectedStakeVoteIx(new PublicKey('EARNynHRWg6GfyJCmrrizcZxARB3HVzcaasvNa8kBS72'))
            // console.log(voteIx)
            // transaction.add(voteIx)

            await this.sendTx(transaction);
            this.goal(); // will die if send tx fails so won't track.

        },
        async unstake() {
            this.loading = true
            this.error = null
            this.success = null
            const {
                associatedMSolTokenAccountAddress,
                transaction,
            } = await this.norefer.liquidUnstake(new BN(this.msolAmount * 1e9))

            await this.sendTx(transaction)
        },
        updateMSolAmount() {
            this.msolAmount = this.amount / this.state.mSolPrice
        },
        goal() {
            if (typeof clicky === 'object') {
                // eslint-disable-next-line
                clicky.goal('Turbo Stake',this.amount)
            }
        },
        async walletBalance() {
            console.log(this.wallet.publicKey)
            let balance = await connection.getBalance(this.wallet.publicKey)
            console.log(balance, "balance")
            this.solBalance = balance / 1e9
            // get msol token balance
            // const msolTokenAccount = await this.marinade.getMSolTokenAccount(this.wallet.publicKey)
            // console.log(msolTokenAccount, "msolTokenAccount")
            // this.msolBalance = msolTokenAccount.amount / 1e9
            const accounts = connection.getParsedTokenAccountsByOwner(
                this.wallet?.publicKey,
                {programId: new PublicKey('TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA')}
            ).then(accounts => {
                let balances = {}
                accounts.value.forEach(account => {
                    const mint = account.account.data.parsed.info.mint
                    balances[mint] = account.account.data.parsed.info.tokenAmount.amount;

                })
                this.balances = balances
                console.log(this.balances)
                this.msolBalance = balances['mSoLzYCxHdYgdzU16g5QSh3i5K3z3KZK7ytfqcJm7So'] /1e9 || 0
            })
        },


    },
    computed: {

    },
    watch: {
        wallet: {
            handler: function (val, oldVal) {
                if (val.connected) {
                    const config = new MarinadeConfig({
                        connection: connection,
                        publicKey: new PublicKey(this.wallet.publicKey),
                        referralCode: new PublicKey(MY_REFERRAL_ACCOUNT),
                    })
                    this.marinade = new Marinade(config)
                    const noRefer = new MarinadeConfig({
                        connection: connection,
                        publicKey: new PublicKey(this.wallet.publicKey),
                    })
                    this.norefer = new Marinade(noRefer)
                    this.walletBalance()
                } else {
                    this.solBalance = 0
                }
            },
            deep: true
        }
    },
}
</script>

<style scoped>
.el-notification__content p {
    text-align: left;
}

.mnde-form.text-light input {
    color: #333 !important;
}
body.dark-mode .mnde-form.text-light input {
    color: #fff;
}

</style>
